import { useState, useEffect } from "react";

import { getExplicitConsent } from "@/src/services/contracts";

import LoaderContractModalWrapper from "components/loader-contract-modal-wrapper";
import Loader from "components/loader";

const ExplicitConsent = () => {
  const [content, setContent] = useState();

  useEffect(() => {
    getExplicitConsent().then((data) => {
      const template = data.data.template;
      setContent(template);
    });
  }, []);

  return (
    <>
      {content ? (
        <div dangerouslySetInnerHTML={{ __html: content }} />
      ) : (
        <LoaderContractModalWrapper>
          <Loader />
        </LoaderContractModalWrapper>
      )}
    </>
  );
};

export default ExplicitConsent;
